import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IWeeklySchedulerOptions, IWeeklySchedulerRange } from '@captiveaire/weeklyscheduler';
import { ITimeRange } from '@caslink/common-client';
import { StringUtilsService } from '@caslink/common-client/ng-app/utilities/StringUtils';

interface DynamicSlotEditorData {
    nullEnds: boolean;
    schedule: IWeeklySchedulerRange<any>;
    weeklySchedulerOptions: IWeeklySchedulerOptions<any>;
}

/**
 * Dynamic slot editor component for dynamic calendars
 */
// tslint:disable max-line-length
@Component({
    selector: 'dl-slot-editor',
    template: `
        <popup-header text="{{ actionText }} slot" (clickAction)="close()"></popup-header>

        <div mat-dialog-content [formGroup]="formGroup">
            <cl-time-range [formGroup]="formGroup" [interval]="data.weeklySchedulerOptions.interval" [nullEnds]="data.nullEnds" [(timeRange)]="timeRange"></cl-time-range>
        </div>

        <popup-button-container>
            <cas-button materialIcon="cancel" (clickAction)="close()" btnText="Cancel"></cas-button>
            <cas-button materialIcon="delete" (clickAction)="delete()" btnText="Delete" *ngIf="data.schedule.$isEditing"></cas-button>
            <cas-button btnClass="md-raised md-accent" (clickAction)="save()" [materialIcon]="actionIcon" [btnText]="actionText" [disabled]="formGroup.invalid"></cas-button>
        </popup-button-container>
    `
})
// tslint:enable max-line-length
export class DynamicSlotEditorComponent implements OnInit {
    public static $name: string = 'clSlotEditor';

    actionIcon: string;
    actionText: string;

    timeRange: ITimeRange;
    formGroup: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<DynamicSlotEditorComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DynamicSlotEditorData,
        private stringUtils: StringUtilsService
    ) {
    }

    public ngOnInit() {
        this.timeRange = {
            start: this.data.schedule.start,
            end: this.data.schedule.end,
            startTime: this.stringUtils.secondsToTimeString(this.data.schedule.start),
            endTime: this.stringUtils.secondsToTimeString(this.data.schedule.end),
            canEdit: true
        };

        this.actionIcon = this.data.schedule.$isEditing ? 'edit' : 'add';
        this.actionText = this.data.schedule.$isEditing ? 'Edit' : 'Add';
        this.formGroup = new FormGroup({});
    }

    public close() {
        // delete changes if modal is not in edit state
        if (this.data.schedule.$isEditing) {
            this.dialogRef.close();
        } else {
            this.delete();
        }
    }

    public delete() {
        this.timeRange.delete = true;
        this.timeRange.start = null;
        this.timeRange.end = null;
        this.save();
    }

    public save() {
        this.dialogRef.close(this.timeRange);
    }
}
